<template>
  <div v-if="post" :id="_id" class="mt-6">
    <OpportunitiesPost v-if="visibility" :post="post" />
    <OpportunitiesExpired v-else :post="post" />
  </div>
</template>

<script setup lang="ts">
import type { QueryOpportunities as Opportunities } from "~/@types/opportunities"
import { getBySlug } from "~/groq/opportunities"

const route = useRoute()

const { data: post } = await useSanityQuery<Opportunities>(getBySlug(), {
  slug: route.params.slug,
})

if (!post.value || isEmpty(post.value)) {
  throw showError({
    statusCode: 404,
    statusMessage: "Page not found",
  })
}

const {
  _id,
  title,
  brand,
  city,
  country,
  metaDescription,
  visibility,
  metaTitle,
  _updatedAt,
} = useOpportunities(post.value)

const { name: countryName } = useCountry(country)
const { name: cityName } = useCity(city)

const seoLocation = [cityName, countryName].filter(Boolean).join(", ")
const seoTitle = metaTitle ?? title

useHead({
  templateParams: {
    brand: brand?.name,
    location: seoLocation,
  },
  title: seoTitle,
  titleTemplate: metaTitle
    ? "%s %separator %siteName"
    : "%s | %brand — %location %separator %siteName",
})

const description =
  (metaDescription ?? brand?.description)?.replace(/(\r\n|\n|\r)/gm, "") ??
  undefined

useSeoMeta({
  articleModifiedTime: _updatedAt,
  description,
})
</script>
